<template>
  <div>
    <van-nav-bar @click-left="$navigateBack">
      <template #left>
        <van-icon size="24" name="arrow-left" />
        <!-- <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" :src="require('/@themes/navBack.png')" alt=""> -->
      </template>
    </van-nav-bar>
    <div class="iframe">
      <iframe :src="url" />

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://baidu.com'
    }
  },
  created() {
    if (this.$route.query.url) {
      this.url = this.$route.query.url
    }
  }

}
</script>

<style leng="scss" scoped>
iframe{
    height: 100% ;
    width:100%;
    border-style: none;
}
.iframe{
    height: calc(100vh - 100px) ;
    width:100%;

}
</style>
